import React, { Fragment } from "react";

import "./Brand.css";
import Button from "../../components/Button/Button";
import BTDForm from "./BTDForm/BTDForm";
import Table from "../../components/Table/Table";
import MessageHandler from "../MessageHandler/MessageHandler";

class Brand extends React.Component {
  constructor(props) {
    super(props);
    this.toggleClass = this.toggleClass.bind(this);
    this.state = {
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    };
  }

  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteBrandHandler = (data) => {
    var Index;
    if(this.props.label !== " سایز" && this.props.label !== " گارانتی" ){
      Index = this.props.tableData.findIndex((p) => p.code === data.code);
    }else{
      Index = this.props.tableData.findIndex((p) => p.code === data.code);
    }
    console.log(Index);
    console.log(this.props.tableData);
    
    
    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.props.tableData[Index].title,
    });
  };

  onEditBrandHandler = (data) => {
    var Index;
    if(this.props.label !== " سایز" && this.props.label !== " گارانتی" ){
      Index = this.props.tableData.findIndex((p) => p.code === data.code);
    }else{
      Index = this.props.tableData.findIndex((p) => p.code === data.code);
    }  
    
    console.log(data);
    console.log(this.props.tableData);
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.props.tableData[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelBrandHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteBrandTypeDicisionHandler = () => {
      this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };
 
  render() {
    return (
      <Fragment>
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelBrandHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelBrandHandler}
          onAcceptModal={this.onDeleteBrandTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <div className="mn-grid__row mn-RD-profile__mt-0 c-profile-doc-upload-container">
          <div className="mn-grid__col">
            <div className="mn-card mn-RD-profile__bdrs-top-0">
              <div className="mn-card__body mn-card__body--form">
                <div className="mn-grid__row">
                  <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 mn-RD-profile__section-title">
                    <span className="mn-RD-profile__title">
                      {"ایجاد" + this.props.label + " کالایی"}
                    </span>
                  </div>
                  <div
                    className={[
                      "mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-2",
                      `${this.state.active && "uk-hidden"}`,
                    ].join(" ")}
                    // style={{ paddingLeft: 0, width: "103px" }}
                  >
                    <Button
                      design="next"
                      mode=""
                      type="submit"
                      loading={false}
                      onClick={this.toggleClass}
                    > 
                      {"افزودن" + this.props.label}
                    </Button>

                    {/* <button
                      className="c-RD-profile__action-btn c-RD-profile__action-btn--upload js-profile-edit-form"
                      onClick={this.toggleClass}
                    >
                      بارگذاری
                    </button> */}
                  </div>
                </div>
                <div
                  className={[
                    "mn-grid__row",
                    `${!this.state.active && "uk-hidden"}`,
                  ].join(" ")}
                >
                  <BTDForm
                    brands={this.props.brands}
                    warranties={this.props.warranties}
                    sizes={this.props.sizes}
                    categoryCode={this.props.categoryCode}
                    toggleClass={this.toggleClass}
                    label={this.props.label}
                    onAcceptModal={this.props.acceptPostChangeHandler.bind(this)}
                    isEditing={this.state.isEditing}
                    editingData={this.state.editingData}
                  />
                </div>

                <div className="mn-grid__row--table ">
                  <Table
                    tableData={this.props.tableData}
                    label={this.props.label}
                    onDeleteHandler={this.onDeleteBrandHandler.bind(this)}
                    onEditHandler={this.onEditBrandHandler.bind(this)}
                  /> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default Brand;
